import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'gen-therapy-tier',
  templateUrl: './therapy-tier.component.html',
  styleUrls: ['./therapy-tier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TherapyTierComponent implements OnInit {
  className: any;
  @Input() hideLabel: boolean = false;
  private _tier = null;
  @Input()
  set tier (tier: number | string) {
    this._tier = tier;
    this.setTier();
  }
  get tier () {
    return this._tier;
  }
  @Input() therapeuticQualifier: string = null;
  public tierString: string = null;
  public tooltipText: string;

  constructor() {
  }

  ngOnInit() {
    if ( this.tier) {
      this.setTier();
    }
  }

  setTier() {
    if (this.tier) {
      this.className = this.tier + '';
      switch (this.tier) {
        case 1:
        case '1':
          this.tooltipText = 'Tier 1: Variants with Strong Clinical Significance';
          this.tierString = 'I';
          break;
        case 2:
        case '2':
          this.tooltipText = 'Tier 2: Variants with Potential Clinical Significance';
          this.tierString = 'II';
          break;
        case 2.5:
        case '2.5':
          this.tooltipText = 'Tier 2.5: Variants with clear biochemical effect but limited clinical significance';
          this.tierString = 'II/III';
          this.className = '2_3';
          break;
        case 3:
        case '3':
          this.tooltipText = 'Tier 3: Variants with Unknown Clinical Significance';
          this.tierString = 'III';
          break;
        case 4:
        case '4':
          this.tooltipText = 'Tier 4: Benign with Likely Benign Variants';
          this.tierString = 'IV';
          break;
        default:
          this.tierString = this.tier + '';
      }
    }
  }

}
